import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IInvestmentsState } from './state';

const state = (state: AppState) => state.investmentsState;

export const investments_Form = createSelector(
  state,
  (state: IInvestmentsState) => state.form
);

export const investments_FormInvestmentOptions = createSelector(
  state,
  (state: IInvestmentsState) => state.form.controls.investments
);

export const investments_DataSaved = createSelector(
  state,
  (state: IInvestmentsState) => state.dataSaved
);

export const investments_InvestmentOptions = createSelector(
  state,
  (state: IInvestmentsState) => state.investmentOptions
);

export const investments_IsManualSplit = createSelector(
  state,
  (state: IInvestmentsState) => state.isManualSplit
);

export const investments_SelectedOptions = createSelector(
  state,
  (state: IInvestmentsState) => {
    var obj = {
      parentId:state.form.controls.investments?.id,
      options:state.form.controls.investments?.controls.map(control => ({
        controlId:control.controls.percentage.id,
        optionId: control.value.investmentOptionId,
        percent:control.value.percentage
      })) 
    }

    return obj;
  }
);

export const investments_TotalPercent = createSelector(
  state,
  (state: IInvestmentsState) => state.form.value.investments?.reduce((a, b) => a + (isNaN(b.percentage) ? 0 : Math.abs(b.percentage)), 0)
);